var Cr = Object.defineProperty;
var Sr = (s, e, t) => e in s ? Cr(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var Ne = (s, e, t) => Sr(s, typeof e != "symbol" ? e + "" : e, t);
var w = /* @__PURE__ */ ((s) => (s[s.Document = 0] = "Document", s[s.DocumentType = 1] = "DocumentType", s[s.Element = 2] = "Element", s[s.Text = 3] = "Text", s[s.CDATA = 4] = "CDATA", s[s.Comment = 5] = "Comment", s))(w || {});
function Qe(s) {
  return s.nodeType === s.ELEMENT_NODE;
}
function xr(s) {
  const e = s == null ? void 0 : s.host;
  return (e == null ? void 0 : e.shadowRoot) === s;
}
function Ae(s) {
  return Object.prototype.toString.call(s) === "[object ShadowRoot]";
}
function vr(s) {
  return s.includes(" background-clip: text;") && !s.includes(" -webkit-background-clip: text;") && (s = s.replace(
    /\sbackground-clip:\s*text;/g,
    " -webkit-background-clip: text; background-clip: text;"
  )), s;
}
function Er(s) {
  const { cssText: e } = s;
  if (e.split('"').length < 3) return e;
  const t = ["@import", `url(${JSON.stringify(s.href)})`];
  return s.layerName === "" ? t.push("layer") : s.layerName && t.push(`layer(${s.layerName})`), s.supportsText && t.push(`supports(${s.supportsText})`), s.media.length && t.push(s.media.mediaText), t.join(" ") + ";";
}
function Rr(s, e) {
  const t = [];
  for (let r = 0; r < s.length; r++) {
    const i = s.item(r);
    s.getPropertyValue(i) === "" && new RegExp(It(i) + ":\\s*;").test(e) && t.push(i);
  }
  return t;
}
function It(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Or(s, e, t, r) {
  const i = Rr(s.style, e);
  if (i.length === 0) return e;
  let n = null;
  try {
    n = t.querySelector(s.selectorText);
  } catch {
  }
  if (!n)
    return r && r.push({
      selector: s.selectorText,
      properties: i
    }), e;
  const l = getComputedStyle(n);
  let a = e;
  for (const o of i) {
    const f = l.getPropertyValue(o);
    if (f) {
      const u = new RegExp(
        `(${It(o)}):\\s*;`
      );
      a = a.replace(u, `$1: ${f};`);
    }
  }
  return a;
}
function de(s, e, t) {
  var r;
  try {
    const i = s.rules || s.cssRules;
    if (!i) return null;
    const n = e || ((r = s.ownerNode) == null ? void 0 : r.ownerDocument) || null, l = Array.from(i, (a) => {
      let o = kr(a);
      return n && _t(a) && (o = Or(
        a,
        o,
        n,
        t
      )), o;
    }).join("");
    return vr(l);
  } catch {
    return null;
  }
}
function kr(s) {
  let e;
  if (Ar(s))
    try {
      e = // for same-origin stylesheets,
      // we can access the imported stylesheet rules directly
      de(s.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
      Er(s);
    } catch {
    }
  else if (_t(s) && s.selectorText.includes(":"))
    return Nr(s.cssText);
  return e || s.cssText;
}
function Nr(s) {
  const e = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return s.replace(e, "$1\\$2");
}
function Ar(s) {
  return "styleSheet" in s;
}
function _t(s) {
  return "selectorText" in s;
}
class Ke {
  constructor() {
    Ne(this, "idNodeMap", /* @__PURE__ */ new Map());
    Ne(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(e) {
    var r;
    return e ? ((r = this.getMeta(e)) == null ? void 0 : r.id) ?? -1 : -1;
  }
  getNode(e) {
    return this.idNodeMap.get(e) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(e) {
    return this.nodeMetaMap.get(e) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(e) {
    const t = this.getId(e);
    this.idNodeMap.delete(t), e.childNodes && e.childNodes.forEach(
      (r) => this.removeNodeFromMap(r)
    );
  }
  has(e) {
    return this.idNodeMap.has(e);
  }
  hasNode(e) {
    return this.nodeMetaMap.has(e);
  }
  add(e, t) {
    const r = t.id;
    this.idNodeMap.set(r, e), this.nodeMetaMap.set(e, t);
  }
  replace(e, t) {
    const r = this.getNode(e);
    if (r) {
      const i = this.nodeMetaMap.get(r);
      i && this.nodeMetaMap.set(t, i);
    }
    this.idNodeMap.set(e, t);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function tn() {
  return new Ke();
}
function Mr({
  element: s,
  maskInputOptions: e,
  tagName: t,
  type: r,
  value: i,
  maskInputFn: n
}) {
  const l = i || "", a = r && Ce(r);
  if (e[t.toLowerCase()] || a && e[a]) {
    const f = n ? n(l, s) : "*".repeat(l.length);
    return { value: f, masked: l !== f };
  }
  return { value: l, masked: !1 };
}
function Ce(s) {
  return s.toLowerCase();
}
const at = "__rrweb_original__";
function Pr(s) {
  const e = s.getContext("2d");
  if (!e) return !0;
  const t = 50;
  for (let r = 0; r < s.width; r += t)
    for (let i = 0; i < s.height; i += t) {
      const n = e.getImageData, l = at in n ? n[at] : n;
      if (new Uint32Array(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        l.call(
          e,
          r,
          i,
          Math.min(t, s.width - r),
          Math.min(t, s.height - i)
        ).data.buffer
      ).some((o) => o !== 0)) return !1;
    }
  return !0;
}
function Ir(s, e) {
  return !s || !e || s.type !== e.type ? !1 : s.type === w.Document ? s.compatMode === e.compatMode : s.type === w.DocumentType ? s.name === e.name && s.publicId === e.publicId && s.systemId === e.systemId : s.type === w.Comment || s.type === w.Text || s.type === w.CDATA ? s.textContent === e.textContent : s.type === w.Element ? s.tagName === e.tagName && JSON.stringify(s.attributes) === JSON.stringify(e.attributes) && s.isSVG === e.isSVG && s.needBlock === e.needBlock : !1;
}
function _r(s) {
  const e = s.type;
  return s.hasAttribute("data-rr-is-password") ? "password" : e ? (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    Ce(e)
  ) : null;
}
function $t(s, e) {
  let t;
  try {
    t = new URL(s, e ?? window.location.href);
  } catch {
    return null;
  }
  const r = /\.([0-9a-z]+)(?:$)/i, i = t.pathname.match(r);
  return (i == null ? void 0 : i[1]) ?? null;
}
let Lt = 1;
const $r = new RegExp("[^a-z0-9-_:]"), ut = -2;
function Lr() {
  return Lt++;
}
function Tr(s) {
  if (s instanceof HTMLFormElement)
    return "form";
  const e = Ce(s.tagName);
  return $r.test(e) ? "div" : e;
}
function Dr(s) {
  let e = "";
  return s.indexOf("//") > -1 ? e = s.split("/").slice(0, 3).join("/") : e = s.split("/")[0], e = e.split("?")[0], e;
}
let z, ft;
const Ur = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, Br = /^(?:[a-z+]+:)?\/\//i, Fr = /^www\..*/i, zr = /^(data:)([^,]*),(.*)/i;
function me(s, e) {
  return (s || "").replace(
    Ur,
    (t, r, i, n, l, a) => {
      const o = i || l || a, f = r || n || "";
      if (!o)
        return t;
      if (Br.test(o) || Fr.test(o))
        return `url(${f}${o}${f})`;
      if (zr.test(o))
        return `url(${f}${o}${f})`;
      if (o[0] === "/")
        return `url(${f}${Dr(e) + o}${f})`;
      const u = e.split("/"), h = o.split("/");
      u.pop();
      for (const d of h)
        d !== "." && (d === ".." ? u.pop() : u.push(d));
      return `url(${f}${u.join("/")}${f})`;
    }
  );
}
const Wr = /^[^ \t\n\r\u000c]+/, jr = /^[, \t\n\r\u000c]+/;
function Gr(s, e) {
  if (e.trim() === "")
    return e;
  let t = 0;
  function r(n) {
    let l;
    const a = n.exec(e.substring(t));
    return a ? (l = a[0], t += l.length, l) : "";
  }
  const i = [];
  for (; r(jr), !(t >= e.length); ) {
    let n = r(Wr);
    if (n.slice(-1) === ",")
      n = W(s, n.substring(0, n.length - 1)), i.push(n);
    else {
      let l = "";
      n = W(s, n);
      let a = !1;
      for (; ; ) {
        const o = e.charAt(t);
        if (o === "") {
          i.push((n + l).trim());
          break;
        } else if (a)
          o === ")" && (a = !1);
        else if (o === ",") {
          t += 1, i.push((n + l).trim());
          break;
        } else o === "(" && (a = !0);
        l += o, t += 1;
      }
    }
  }
  return i.join(", ");
}
const ct = /* @__PURE__ */ new WeakMap();
function W(s, e) {
  return !e || e.trim() === "" ? e : Se(s, e);
}
function Vr(s) {
  return !!(s.tagName === "svg" || s.ownerSVGElement);
}
function Se(s, e) {
  let t = ct.get(s);
  if (t || (t = s.createElement("a"), ct.set(s, t)), !e)
    e = "";
  else if (e.startsWith("blob:") || e.startsWith("data:"))
    return e;
  return t.setAttribute("href", e), t.href;
}
function Hr(s, e, t, r) {
  return r && (t === "src" || t === "href" && !(e === "use" && r[0] === "#") || t === "xlink:href" && r[0] !== "#" || t === "background" && (e === "table" || e === "td" || e === "th") ? W(s, r) : t === "srcset" ? Gr(s, r) : t === "style" ? me(r, Se(s)) : e === "object" && t === "data" ? W(s, r) : r);
}
function Jr(s, e, t) {
  return (s === "video" || s === "audio") && e === "autoplay";
}
function Yr(s, e, t) {
  try {
    if (typeof e == "string") {
      if (s.classList.contains(e))
        return !0;
    } else
      for (let r = s.classList.length; r--; ) {
        const i = s.classList[r];
        if (e.test(i))
          return !0;
      }
    if (t)
      return s.matches(t);
  } catch {
  }
  return !1;
}
function $e(s, e, t) {
  if (!s) return !1;
  if (s.nodeType !== s.ELEMENT_NODE)
    return t ? $e(s.parentNode, e, t) : !1;
  for (let r = s.classList.length; r--; ) {
    const i = s.classList[r];
    if (e.test(i))
      return !0;
  }
  return t ? $e(s.parentNode, e, t) : !1;
}
function qr(s, e, t, r) {
  let i;
  if (Qe(s)) {
    if (i = s, !i.childNodes.length)
      return !1;
  } else {
    if (s.parentElement === null)
      return !1;
    i = s.parentElement;
  }
  try {
    if (typeof e == "string") {
      if (r) {
        if (i.closest(`.${e}`)) return !0;
      } else if (i.classList.contains(e)) return !0;
    } else if ($e(i, e, r)) return !0;
    if (t) {
      if (r) {
        if (i.closest(t)) return !0;
      } else if (i.matches(t)) return !0;
    }
  } catch {
  }
  return !1;
}
function Qr(s, e, t) {
  const r = s.contentWindow;
  if (!r)
    return;
  let i = !1, n;
  try {
    n = r.document.readyState;
  } catch {
    return;
  }
  if (n !== "complete") {
    const a = setTimeout(() => {
      i || (e(), i = !0);
    }, t);
    s.addEventListener("load", () => {
      clearTimeout(a), i = !0, e();
    });
    return;
  }
  const l = "about:blank";
  if (r.location.href !== l || s.src === l || s.src === "")
    return setTimeout(e, 0), s.addEventListener("load", e);
  s.addEventListener("load", e);
}
function Kr(s, e, t) {
  let r = !1, i;
  try {
    i = s.sheet;
  } catch {
    return;
  }
  if (i) return;
  const n = setTimeout(() => {
    r || (e(), r = !0);
  }, t);
  s.addEventListener("load", () => {
    clearTimeout(n), r = !0, e();
  });
}
function Xr(s, e) {
  const {
    doc: t,
    mirror: r,
    blockClass: i,
    blockSelector: n,
    needsMask: l,
    inlineStylesheet: a,
    maskInputOptions: o = {},
    maskTextFn: f,
    maskInputFn: u,
    dataURLOptions: h = {},
    inlineImages: d,
    recordCanvas: g,
    keepIframeSrcFn: E,
    newlyAddedElement: R = !1,
    corruptedRules: c
  } = e, m = Zr(t, r);
  switch (s.nodeType) {
    case s.DOCUMENT_NODE:
      return s.compatMode !== "CSS1Compat" ? {
        type: w.Document,
        childNodes: [],
        compatMode: s.compatMode
        // probably "BackCompat"
      } : {
        type: w.Document,
        childNodes: []
      };
    case s.DOCUMENT_TYPE_NODE:
      return {
        type: w.DocumentType,
        name: s.name,
        publicId: s.publicId,
        systemId: s.systemId,
        rootId: m
      };
    case s.ELEMENT_NODE:
      return ts(s, {
        doc: t,
        blockClass: i,
        blockSelector: n,
        inlineStylesheet: a,
        maskInputOptions: o,
        maskInputFn: u,
        dataURLOptions: h,
        inlineImages: d,
        recordCanvas: g,
        keepIframeSrcFn: E,
        newlyAddedElement: R,
        rootId: m,
        corruptedRules: c
      });
    case s.TEXT_NODE:
      return es(s, {
        doc: t,
        needsMask: l,
        maskTextFn: f,
        rootId: m,
        corruptedRules: c
      });
    case s.CDATA_SECTION_NODE:
      return {
        type: w.CDATA,
        textContent: "",
        rootId: m
      };
    case s.COMMENT_NODE:
      return {
        type: w.Comment,
        textContent: s.textContent || "",
        rootId: m
      };
    default:
      return !1;
  }
}
function Zr(s, e) {
  if (!e.hasNode(s)) return;
  const t = e.getId(s);
  return t === 1 ? void 0 : t;
}
function es(s, e) {
  var f;
  const { needsMask: t, maskTextFn: r, rootId: i } = e, n = s.parentNode && s.parentNode.tagName;
  let l = s.textContent;
  const a = n === "STYLE" ? !0 : void 0, o = n === "SCRIPT" ? !0 : void 0;
  if (a && l) {
    try {
      s.nextSibling || s.previousSibling || (f = s.parentNode.sheet) != null && f.cssRules && (l = de(
        s.parentNode.sheet,
        e.doc,
        e.corruptedRules
      ) || "");
    } catch (u) {
      console.warn(
        `Cannot get CSS styles from text's parentNode. Error: ${u}`,
        s
      );
    }
    l = me(l, Se(e.doc));
  }
  return o && (l = "SCRIPT_PLACEHOLDER"), !a && !o && l && t && (l = r ? r(l, s.parentElement) : l.replace(/[\S]/g, "*")), {
    type: w.Text,
    textContent: l || "",
    isStyle: a,
    rootId: i
  };
}
function ts(s, e) {
  const {
    doc: t,
    blockClass: r,
    blockSelector: i,
    inlineStylesheet: n,
    maskInputOptions: l = {},
    maskInputFn: a,
    dataURLOptions: o = {},
    inlineImages: f,
    recordCanvas: u,
    keepIframeSrcFn: h,
    newlyAddedElement: d = !1,
    rootId: g,
    corruptedRules: E
  } = e, R = Yr(s, r, i), c = Tr(s);
  let m = {};
  const k = s.attributes.length;
  for (let p = 0; p < k; p++) {
    const b = s.attributes[p];
    Jr(c, b.name, b.value) || (m[b.name] = Hr(
      t,
      c,
      Ce(b.name),
      b.value
    ));
  }
  if (c === "link" && n) {
    const p = Array.from(t.styleSheets).find((O) => O.href === s.href);
    let b = null;
    p && (b = de(p, t, E)), b && (delete m.rel, delete m.href, m._cssText = me(b, p.href));
  }
  if (c === "style" && s.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
  !(s.innerText || s.textContent || "").trim().length) {
    const p = de(
      s.sheet,
      t,
      E
    );
    p && (m._cssText = me(p, Se(t)));
  }
  if (E && E.length > 0 && !R) {
    const p = typeof m.style == "string" ? m.style : "";
    let b = "";
    for (const { selector: O, properties: I } of E)
      try {
        if (s.matches(O)) {
          const A = getComputedStyle(s);
          for (const N of I)
            if (!s.style.getPropertyValue(N)) {
              const _ = A.getPropertyValue(N);
              _ && (b += `${N}: ${_}; `);
            }
        }
      } catch {
      }
    b && (m.style = p ? `${p}; ${b.trim()}` : b.trim());
  }
  if (c === "input" || c === "textarea" || c === "select") {
    const p = s.value, b = s.checked;
    if (m.type !== "radio" && m.type !== "checkbox" && m.type !== "submit" && m.type !== "button" && p) {
      const O = Mr({
        element: s,
        type: _r(s),
        tagName: c,
        value: p,
        maskInputOptions: l,
        maskInputFn: a
      });
      m.value = O.value, O.masked && (m.masked = !0);
    } else b && (m.checked = b);
  }
  if (c === "option" && (s.selected && !l.select ? m.selected = !0 : delete m.selected), c === "canvas" && u) {
    if (s.__context === "2d")
      Pr(s) || (m.rr_dataURL = s.toDataURL(
        o.type,
        o.quality
      ));
    else if (!("__context" in s)) {
      const p = s.toDataURL(
        o.type,
        o.quality
      ), b = t.createElement("canvas");
      b.width = s.width, b.height = s.height;
      const O = b.toDataURL(
        o.type,
        o.quality
      );
      p !== O && (m.rr_dataURL = p);
    }
  }
  if (c === "img" && f) {
    z || (z = t.createElement("canvas"), ft = z.getContext("2d"));
    const p = s, b = p.currentSrc || p.getAttribute("src") || "<unknown-src>", O = p.crossOrigin, I = () => {
      p.removeEventListener("load", I);
      try {
        z.width = p.naturalWidth, z.height = p.naturalHeight, ft.drawImage(p, 0, 0), m.rr_dataURL = z.toDataURL(
          o.type,
          o.quality
        );
      } catch (A) {
        if (p.crossOrigin !== "anonymous") {
          p.crossOrigin = "anonymous", p.complete && p.naturalWidth !== 0 ? I() : p.addEventListener("load", I);
          return;
        } else
          console.warn(
            `Cannot inline img src=${b}! Error: ${A}`
          );
      }
      p.crossOrigin === "anonymous" && (O ? m.crossOrigin = O : p.removeAttribute("crossorigin"));
    };
    p.complete && p.naturalWidth !== 0 ? I() : p.addEventListener("load", I);
  }
  if (c === "audio" || c === "video") {
    const p = m;
    p.rr_mediaState = s.paused ? "paused" : "played", p.rr_mediaCurrentTime = s.currentTime, p.rr_mediaPlaybackRate = s.playbackRate, p.rr_mediaMuted = s.muted, p.rr_mediaLoop = s.loop, p.rr_mediaVolume = s.volume;
  }
  if (d || (s.scrollLeft && (m.rr_scrollLeft = s.scrollLeft), s.scrollTop && (m.rr_scrollTop = s.scrollTop)), R) {
    const { width: p, height: b } = s.getBoundingClientRect();
    m = {
      class: m.class,
      rr_width: `${p}px`,
      rr_height: `${b}px`
    };
  }
  c === "iframe" && !h(m.src) && (s.contentDocument || (m.rr_src = m.src), delete m.src);
  let M;
  try {
    customElements.get(c) && (M = !0);
  } catch {
  }
  return {
    type: w.Element,
    tagName: c,
    attributes: m,
    childNodes: [],
    isSVG: Vr(s) || void 0,
    needBlock: R,
    rootId: g,
    isCustom: M
  };
}
function S(s) {
  return s == null ? "" : s.toLowerCase();
}
function rs(s, e) {
  if (e.comment && s.type === w.Comment)
    return !0;
  if (s.type === w.Element) {
    if (e.script && // script tag
    (s.tagName === "script" || // (module)preload link
    s.tagName === "link" && (s.attributes.rel === "preload" || s.attributes.rel === "modulepreload") && s.attributes.as === "script" || // prefetch link
    s.tagName === "link" && s.attributes.rel === "prefetch" && typeof s.attributes.href == "string" && $t(s.attributes.href) === "js"))
      return !0;
    if (e.headFavicon && (s.tagName === "link" && s.attributes.rel === "shortcut icon" || s.tagName === "meta" && (S(s.attributes.name).match(
      /^msapplication-tile(image|color)$/
    ) || S(s.attributes.name) === "application-name" || S(s.attributes.rel) === "icon" || S(s.attributes.rel) === "apple-touch-icon" || S(s.attributes.rel) === "shortcut icon")))
      return !0;
    if (s.tagName === "meta") {
      if (e.headMetaDescKeywords && S(s.attributes.name).match(/^description|keywords$/))
        return !0;
      if (e.headMetaSocial && (S(s.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
      S(s.attributes.name).match(/^(og|twitter):/) || S(s.attributes.name) === "pinterest"))
        return !0;
      if (e.headMetaRobots && (S(s.attributes.name) === "robots" || S(s.attributes.name) === "googlebot" || S(s.attributes.name) === "bingbot"))
        return !0;
      if (e.headMetaHttpEquiv && s.attributes["http-equiv"] !== void 0)
        return !0;
      if (e.headMetaAuthorship && (S(s.attributes.name) === "author" || S(s.attributes.name) === "generator" || S(s.attributes.name) === "framework" || S(s.attributes.name) === "publisher" || S(s.attributes.name) === "progid" || S(s.attributes.property).match(/^article:/) || S(s.attributes.property).match(/^product:/)))
        return !0;
      if (e.headMetaVerification && (S(s.attributes.name) === "google-site-verification" || S(s.attributes.name) === "yandex-verification" || S(s.attributes.name) === "csrf-token" || S(s.attributes.name) === "p:domain_verify" || S(s.attributes.name) === "verify-v1" || S(s.attributes.name) === "verification" || S(s.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function K(s, e) {
  const {
    doc: t,
    mirror: r,
    blockClass: i,
    blockSelector: n,
    maskTextClass: l,
    maskTextSelector: a,
    skipChild: o = !1,
    inlineStylesheet: f = !0,
    maskInputOptions: u = {},
    maskTextFn: h,
    maskInputFn: d,
    slimDOMOptions: g,
    dataURLOptions: E = {},
    inlineImages: R = !1,
    recordCanvas: c = !1,
    onSerialize: m,
    onIframeLoad: k,
    iframeLoadTimeout: M = 5e3,
    onStylesheetLoad: p,
    stylesheetLoadTimeout: b = 5e3,
    keepIframeSrcFn: O = () => !1,
    newlyAddedElement: I = !1,
    corruptedRules: A
  } = e;
  let { needsMask: N } = e, { preserveWhiteSpace: _ = !0 } = e;
  N || (N = qr(
    s,
    l,
    a,
    N === void 0
  ));
  const U = Xr(s, {
    doc: t,
    mirror: r,
    blockClass: i,
    blockSelector: n,
    needsMask: N,
    inlineStylesheet: f,
    maskInputOptions: u,
    maskTextFn: h,
    maskInputFn: d,
    dataURLOptions: E,
    inlineImages: R,
    recordCanvas: c,
    keepIframeSrcFn: O,
    newlyAddedElement: I,
    corruptedRules: A
  });
  if (!U)
    return console.warn(s, "not serialized"), null;
  let H;
  r.hasNode(s) ? H = r.getId(s) : rs(U, g) || !_ && U.type === w.Text && !U.isStyle && !U.textContent.replace(/^\s+|\s+$/gm, "").length ? H = ut : H = Lr();
  const x = Object.assign(U, { id: H });
  if (r.add(s, x), H === ut)
    return null;
  m && m(s);
  let ke = !o;
  if (x.type === w.Element) {
    ke = ke && !x.needBlock, delete x.needBlock;
    const P = s.shadowRoot;
    P && Ae(P) && (x.isShadowHost = !0);
  }
  if ((x.type === w.Document || x.type === w.Element) && ke) {
    g.headWhitespace && x.type === w.Element && x.tagName === "head" && (_ = !1);
    const P = {
      doc: t,
      mirror: r,
      blockClass: i,
      blockSelector: n,
      needsMask: N,
      maskTextClass: l,
      maskTextSelector: a,
      skipChild: o,
      inlineStylesheet: f,
      maskInputOptions: u,
      maskTextFn: h,
      maskInputFn: d,
      slimDOMOptions: g,
      dataURLOptions: E,
      inlineImages: R,
      recordCanvas: c,
      preserveWhiteSpace: _,
      onSerialize: m,
      onIframeLoad: k,
      iframeLoadTimeout: M,
      onStylesheetLoad: p,
      stylesheetLoadTimeout: b,
      keepIframeSrcFn: O,
      corruptedRules: A
    };
    if (!(x.type === w.Element && x.tagName === "textarea" && x.attributes.value !== void 0)) for (const B of Array.from(s.childNodes)) {
      const F = K(B, P);
      F && x.childNodes.push(F);
    }
    if (Qe(s) && s.shadowRoot)
      for (const B of Array.from(s.shadowRoot.childNodes)) {
        const F = K(B, P);
        F && (Ae(s.shadowRoot) && (F.isShadow = !0), x.childNodes.push(F));
      }
  }
  return s.parentNode && xr(s.parentNode) && Ae(s.parentNode) && (x.isShadow = !0), x.type === w.Element && x.tagName === "iframe" && Qr(
    s,
    () => {
      const P = s.contentDocument;
      if (P && k) {
        const B = K(P, {
          doc: P,
          mirror: r,
          blockClass: i,
          blockSelector: n,
          needsMask: N,
          maskTextClass: l,
          maskTextSelector: a,
          skipChild: !1,
          inlineStylesheet: f,
          maskInputOptions: u,
          maskTextFn: h,
          maskInputFn: d,
          slimDOMOptions: g,
          dataURLOptions: E,
          inlineImages: R,
          recordCanvas: c,
          preserveWhiteSpace: _,
          onSerialize: m,
          onIframeLoad: k,
          iframeLoadTimeout: M,
          onStylesheetLoad: p,
          stylesheetLoadTimeout: b,
          keepIframeSrcFn: O
        });
        B && k(
          s,
          B
        );
      }
    },
    M
  ), x.type === w.Element && x.tagName === "link" && typeof x.attributes.rel == "string" && (x.attributes.rel === "stylesheet" || x.attributes.rel === "preload" && typeof x.attributes.href == "string" && $t(x.attributes.href) === "css") && Kr(
    s,
    () => {
      if (p) {
        const P = K(s, {
          doc: t,
          mirror: r,
          blockClass: i,
          blockSelector: n,
          needsMask: N,
          maskTextClass: l,
          maskTextSelector: a,
          skipChild: !1,
          inlineStylesheet: f,
          maskInputOptions: u,
          maskTextFn: h,
          maskInputFn: d,
          slimDOMOptions: g,
          dataURLOptions: E,
          inlineImages: R,
          recordCanvas: c,
          preserveWhiteSpace: _,
          onSerialize: m,
          onIframeLoad: k,
          iframeLoadTimeout: M,
          onStylesheetLoad: p,
          stylesheetLoadTimeout: b,
          keepIframeSrcFn: O
        });
        P && p(
          s,
          P
        );
      }
    },
    b
  ), x;
}
function rn(s, e) {
  const {
    mirror: t = new Ke(),
    blockClass: r = "rr-block",
    blockSelector: i = null,
    maskTextClass: n = "rr-mask",
    maskTextSelector: l = null,
    inlineStylesheet: a = !0,
    inlineImages: o = !1,
    recordCanvas: f = !1,
    maskAllInputs: u = !1,
    maskTextFn: h,
    maskInputFn: d,
    slimDOM: g = !1,
    dataURLOptions: E,
    preserveWhiteSpace: R,
    onSerialize: c,
    onIframeLoad: m,
    iframeLoadTimeout: k,
    onStylesheetLoad: M,
    stylesheetLoadTimeout: p,
    keepIframeSrcFn: b = () => !1,
    corruptedRules: O
  } = e || {};
  return K(s, {
    doc: s,
    mirror: t,
    blockClass: r,
    blockSelector: i,
    maskTextClass: n,
    maskTextSelector: l,
    skipChild: !1,
    inlineStylesheet: a,
    maskInputOptions: u === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0,
      password: !0
    } : u === !1 ? {
      password: !0
    } : u,
    maskTextFn: h,
    maskInputFn: d,
    slimDOMOptions: g === !0 || g === "all" ? (
      // if true: set of sensible options that should not throw away any information
      {
        script: !0,
        comment: !0,
        headFavicon: !0,
        headWhitespace: !0,
        headMetaDescKeywords: g === "all",
        // destructive
        headMetaSocial: !0,
        headMetaRobots: !0,
        headMetaHttpEquiv: !0,
        headMetaAuthorship: !0,
        headMetaVerification: !0
      }
    ) : g === !1 ? {} : g,
    dataURLOptions: E,
    inlineImages: o,
    recordCanvas: f,
    preserveWhiteSpace: R,
    onSerialize: c,
    onIframeLoad: m,
    iframeLoadTimeout: k,
    onStylesheetLoad: M,
    stylesheetLoadTimeout: p,
    keepIframeSrcFn: b,
    newlyAddedElement: !1,
    corruptedRules: O
  });
}
function sn(s, e) {
  function t(r) {
    e(r), (r.type === w.Document || r.type === w.Element) && r.childNodes.forEach(t);
  }
  t(s);
}
function nn() {
  Lt = 1;
}
function ss(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
function is(s) {
  if (s.__esModule) return s;
  var e = s.default;
  if (typeof e == "function") {
    var t = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(s).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(s, r);
    Object.defineProperty(t, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return s[r];
      }
    });
  }), t;
}
var Xe = { exports: {} }, y = String, Tt = function() {
  return { isColorSupported: !1, reset: y, bold: y, dim: y, italic: y, underline: y, inverse: y, hidden: y, strikethrough: y, black: y, red: y, green: y, yellow: y, blue: y, magenta: y, cyan: y, white: y, gray: y, bgBlack: y, bgRed: y, bgGreen: y, bgYellow: y, bgBlue: y, bgMagenta: y, bgCyan: y, bgWhite: y, blackBright: y, redBright: y, greenBright: y, yellowBright: y, blueBright: y, magentaBright: y, cyanBright: y, whiteBright: y, bgBlackBright: y, bgRedBright: y, bgGreenBright: y, bgYellowBright: y, bgBlueBright: y, bgMagentaBright: y, bgCyanBright: y, bgWhiteBright: y };
};
Xe.exports = Tt();
Xe.exports.createColors = Tt;
var ns = Xe.exports;
const os = {}, ls = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: os
}, Symbol.toStringTag, { value: "Module" })), $ = /* @__PURE__ */ is(ls);
let ht = ns, pt = $, Le = class Dt extends Error {
  constructor(e, t, r, i, n, l) {
    super(e), this.name = "CssSyntaxError", this.reason = e, n && (this.file = n), i && (this.source = i), l && (this.plugin = l), typeof t < "u" && typeof r < "u" && (typeof t == "number" ? (this.line = t, this.column = r) : (this.line = t.line, this.column = t.column, this.endLine = r.line, this.endColumn = r.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, Dt);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(e) {
    if (!this.source) return "";
    let t = this.source;
    e == null && (e = ht.isColorSupported);
    let r = (u) => u, i = (u) => u, n = (u) => u;
    if (e) {
      let { bold: u, gray: h, red: d } = ht.createColors(!0);
      i = (g) => u(d(g)), r = (g) => h(g), pt && (n = (g) => pt(g));
    }
    let l = t.split(/\r?\n/), a = Math.max(this.line - 3, 0), o = Math.min(this.line + 2, l.length), f = String(o).length;
    return l.slice(a, o).map((u, h) => {
      let d = a + 1 + h, g = " " + (" " + d).slice(-f) + " | ";
      if (d === this.line) {
        if (u.length > 160) {
          let R = 20, c = Math.max(0, this.column - R), m = Math.max(
            this.column + R,
            this.endColumn + R
          ), k = u.slice(c, m), M = r(g.replace(/\d/g, " ")) + u.slice(0, Math.min(this.column - 1, R - 1)).replace(/[^\t]/g, " ");
          return i(">") + r(g) + n(k) + `
 ` + M + i("^");
        }
        let E = r(g.replace(/\d/g, " ")) + u.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return i(">") + r(g) + n(u) + `
 ` + E + i("^");
      }
      return " " + r(g) + n(u);
    }).join(`
`);
  }
  toString() {
    let e = this.showSourceCode();
    return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
  }
};
var Ze = Le;
Le.default = Le;
const dt = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function as(s) {
  return s[0].toUpperCase() + s.slice(1);
}
let Te = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, t) {
    let r = "@" + e.name, i = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName < "u" ? r += e.raws.afterName : i && (r += " "), e.nodes)
      this.block(e, r + i);
    else {
      let n = (e.raws.between || "") + (t ? ";" : "");
      this.builder(r + i + n, e);
    }
  }
  beforeAfter(e, t) {
    let r;
    e.type === "decl" ? r = this.raw(e, null, "beforeDecl") : e.type === "comment" ? r = this.raw(e, null, "beforeComment") : t === "before" ? r = this.raw(e, null, "beforeRule") : r = this.raw(e, null, "beforeClose");
    let i = e.parent, n = 0;
    for (; i && i.type !== "root"; )
      n += 1, i = i.parent;
    if (r.includes(`
`)) {
      let l = this.raw(e, null, "indent");
      if (l.length)
        for (let a = 0; a < n; a++) r += l;
    }
    return r;
  }
  block(e, t) {
    let r = this.raw(e, "between", "beforeOpen");
    this.builder(t + r + "{", e, "start");
    let i;
    e.nodes && e.nodes.length ? (this.body(e), i = this.raw(e, "after")) : i = this.raw(e, "after", "emptyBody"), i && this.builder(i), this.builder("}", e, "end");
  }
  body(e) {
    let t = e.nodes.length - 1;
    for (; t > 0 && e.nodes[t].type === "comment"; )
      t -= 1;
    let r = this.raw(e, "semicolon");
    for (let i = 0; i < e.nodes.length; i++) {
      let n = e.nodes[i], l = this.raw(n, "before");
      l && this.builder(l), this.stringify(n, t !== i || r);
    }
  }
  comment(e) {
    let t = this.raw(e, "left", "commentLeft"), r = this.raw(e, "right", "commentRight");
    this.builder("/*" + t + e.text + r + "*/", e);
  }
  decl(e, t) {
    let r = this.raw(e, "between", "colon"), i = e.prop + r + this.rawValue(e, "value");
    e.important && (i += e.raws.important || " !important"), t && (i += ";"), this.builder(i, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, t, r) {
    let i;
    if (r || (r = t), t && (i = e.raws[t], typeof i < "u"))
      return i;
    let n = e.parent;
    if (r === "before" && (!n || n.type === "root" && n.first === e || n && n.type === "document"))
      return "";
    if (!n) return dt[r];
    let l = e.root();
    if (l.rawCache || (l.rawCache = {}), typeof l.rawCache[r] < "u")
      return l.rawCache[r];
    if (r === "before" || r === "after")
      return this.beforeAfter(e, r);
    {
      let a = "raw" + as(r);
      this[a] ? i = this[a](l, e) : l.walk((o) => {
        if (i = o.raws[t], typeof i < "u") return !1;
      });
    }
    return typeof i > "u" && (i = dt[r]), l.rawCache[r] = i, i;
  }
  rawBeforeClose(e) {
    let t;
    return e.walk((r) => {
      if (r.nodes && r.nodes.length > 0 && typeof r.raws.after < "u")
        return t = r.raws.after, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeComment(e, t) {
    let r;
    return e.walkComments((i) => {
      if (typeof i.raws.before < "u")
        return r = i.raws.before, r.includes(`
`) && (r = r.replace(/[^\n]+$/, "")), !1;
    }), typeof r > "u" ? r = this.raw(t, null, "beforeDecl") : r && (r = r.replace(/\S/g, "")), r;
  }
  rawBeforeDecl(e, t) {
    let r;
    return e.walkDecls((i) => {
      if (typeof i.raws.before < "u")
        return r = i.raws.before, r.includes(`
`) && (r = r.replace(/[^\n]+$/, "")), !1;
    }), typeof r > "u" ? r = this.raw(t, null, "beforeRule") : r && (r = r.replace(/\S/g, "")), r;
  }
  rawBeforeOpen(e) {
    let t;
    return e.walk((r) => {
      if (r.type !== "decl" && (t = r.raws.between, typeof t < "u"))
        return !1;
    }), t;
  }
  rawBeforeRule(e) {
    let t;
    return e.walk((r) => {
      if (r.nodes && (r.parent !== e || e.first !== r) && typeof r.raws.before < "u")
        return t = r.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawColon(e) {
    let t;
    return e.walkDecls((r) => {
      if (typeof r.raws.between < "u")
        return t = r.raws.between.replace(/[^\s:]/g, ""), !1;
    }), t;
  }
  rawEmptyBody(e) {
    let t;
    return e.walk((r) => {
      if (r.nodes && r.nodes.length === 0 && (t = r.raws.after, typeof t < "u"))
        return !1;
    }), t;
  }
  rawIndent(e) {
    if (e.raws.indent) return e.raws.indent;
    let t;
    return e.walk((r) => {
      let i = r.parent;
      if (i && i !== e && i.parent && i.parent === e && typeof r.raws.before < "u") {
        let n = r.raws.before.split(`
`);
        return t = n[n.length - 1], t = t.replace(/\S/g, ""), !1;
      }
    }), t;
  }
  rawSemicolon(e) {
    let t;
    return e.walk((r) => {
      if (r.nodes && r.nodes.length && r.last.type === "decl" && (t = r.raws.semicolon, typeof t < "u"))
        return !1;
    }), t;
  }
  rawValue(e, t) {
    let r = e[t], i = e.raws[t];
    return i && i.value === r ? i.raw : r;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, t) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, t);
  }
};
var Ut = Te;
Te.default = Te;
let us = Ut;
function De(s, e) {
  new us(e).stringify(s);
}
var xe = De;
De.default = De;
var re = {};
re.isClean = Symbol("isClean");
re.my = Symbol("my");
let fs = Ze, cs = Ut, hs = xe, { isClean: J, my: ps } = re;
function Ue(s, e) {
  let t = new s.constructor();
  for (let r in s) {
    if (!Object.prototype.hasOwnProperty.call(s, r) || r === "proxyCache") continue;
    let i = s[r], n = typeof i;
    r === "parent" && n === "object" ? e && (t[r] = e) : r === "source" ? t[r] = i : Array.isArray(i) ? t[r] = i.map((l) => Ue(l, t)) : (n === "object" && i !== null && (i = Ue(i)), t[r] = i);
  }
  return t;
}
function Y(s, e) {
  if (e && typeof e.offset < "u")
    return e.offset;
  let t = 1, r = 1, i = 0;
  for (let n = 0; n < s.length; n++) {
    if (r === e.line && t === e.column) {
      i = n;
      break;
    }
    s[n] === `
` ? (t = 1, r += 1) : t += 1;
  }
  return i;
}
let Be = class {
  get proxyOf() {
    return this;
  }
  constructor(e = {}) {
    this.raws = {}, this[J] = !1, this[ps] = !0;
    for (let t in e)
      if (t === "nodes") {
        this.nodes = [];
        for (let r of e[t])
          typeof r.clone == "function" ? this.append(r.clone()) : this.append(r);
      } else
        this[t] = e[t];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let t = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let t in e)
      this[t] = e[t];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let t = Ue(this);
    for (let r in e)
      t[r] = e[r];
    return t;
  }
  cloneAfter(e = {}) {
    let t = this.clone(e);
    return this.parent.insertAfter(this, t), t;
  }
  cloneBefore(e = {}) {
    let t = this.clone(e);
    return this.parent.insertBefore(this, t), t;
  }
  error(e, t = {}) {
    if (this.source) {
      let { end: r, start: i } = this.rangeBy(t);
      return this.source.input.error(
        e,
        { column: i.column, line: i.line },
        { column: r.column, line: r.line },
        t
      );
    }
    return new fs(e);
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
      },
      set(e, t, r) {
        return e[t] === r || (e[t] = r, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
        t === "text") && e.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[J] = !0;
  }
  markDirty() {
    if (this[J]) {
      this[J] = !1;
      let e = this;
      for (; e = e.parent; )
        e[J] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e) {
    let t = this.source.start;
    if (e.index)
      t = this.positionInside(e.index);
    else if (e.word) {
      let r = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = r.slice(
        Y(r, this.source.start),
        Y(r, this.source.end)
      ).indexOf(e.word);
      n !== -1 && (t = this.positionInside(n));
    }
    return t;
  }
  positionInside(e) {
    let t = this.source.start.column, r = this.source.start.line, i = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = Y(i, this.source.start), l = n + e;
    for (let a = n; a < l; a++)
      i[a] === `
` ? (t = 1, r += 1) : t += 1;
    return { column: t, line: r };
  }
  prev() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e) {
    let t = {
      column: this.source.start.column,
      line: this.source.start.line
    }, r = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: t.column + 1,
      line: t.line
    };
    if (e.word) {
      let i = "document" in this.source.input ? this.source.input.document : this.source.input.css, l = i.slice(
        Y(i, this.source.start),
        Y(i, this.source.end)
      ).indexOf(e.word);
      l !== -1 && (t = this.positionInside(l), r = this.positionInside(
        l + e.word.length
      ));
    } else
      e.start ? t = {
        column: e.start.column,
        line: e.start.line
      } : e.index && (t = this.positionInside(e.index)), e.end ? r = {
        column: e.end.column,
        line: e.end.line
      } : typeof e.endIndex == "number" ? r = this.positionInside(e.endIndex) : e.index && (r = this.positionInside(e.index + 1));
    return (r.line < t.line || r.line === t.line && r.column <= t.column) && (r = { column: t.column + 1, line: t.line }), { end: r, start: t };
  }
  raw(e, t) {
    return new cs().raw(this, e, t);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let t = this, r = !1;
      for (let i of e)
        i === this ? r = !0 : r ? (this.parent.insertAfter(t, i), t = i) : this.parent.insertBefore(t, i);
      r || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, t) {
    let r = {}, i = t == null;
    t = t || /* @__PURE__ */ new Map();
    let n = 0;
    for (let l in this) {
      if (!Object.prototype.hasOwnProperty.call(this, l) || l === "parent" || l === "proxyCache") continue;
      let a = this[l];
      if (Array.isArray(a))
        r[l] = a.map((o) => typeof o == "object" && o.toJSON ? o.toJSON(null, t) : o);
      else if (typeof a == "object" && a.toJSON)
        r[l] = a.toJSON(null, t);
      else if (l === "source") {
        let o = t.get(a.input);
        o == null && (o = n, t.set(a.input, n), n++), r[l] = {
          end: a.end,
          inputId: o,
          start: a.start
        };
      } else
        r[l] = a;
    }
    return i && (r.inputs = [...t.keys()].map((l) => l.toJSON())), r;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = hs) {
    e.stringify && (e = e.stringify);
    let t = "";
    return e(this, (r) => {
      t += r;
    }), t;
  }
  warn(e, t, r) {
    let i = { node: this };
    for (let n in r) i[n] = r[n];
    return e.warn(t, i);
  }
};
var ve = Be;
Be.default = Be;
let ds = ve, Fe = class extends ds {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var Ee = Fe;
Fe.default = Fe;
let ms = ve, ze = class extends ms {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(e) {
    e && typeof e.value < "u" && typeof e.value != "string" && (e = { ...e, value: String(e.value) }), super(e), this.type = "decl";
  }
};
var Re = ze;
ze.default = ze;
let Bt = Ee, Ft = Re, gs = ve, { isClean: zt, my: Wt } = re, et, jt, Gt, tt;
function Vt(s) {
  return s.map((e) => (e.nodes && (e.nodes = Vt(e.nodes)), delete e.source, e));
}
function Ht(s) {
  if (s[zt] = !1, s.proxyOf.nodes)
    for (let e of s.proxyOf.nodes)
      Ht(e);
}
let T = class Jt extends gs {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...e) {
    for (let t of e) {
      let r = this.normalize(t, this.last);
      for (let i of r) this.proxyOf.nodes.push(i);
    }
    return this.markDirty(), this;
  }
  cleanRaws(e) {
    if (super.cleanRaws(e), this.nodes)
      for (let t of this.nodes) t.cleanRaws(e);
  }
  each(e) {
    if (!this.proxyOf.nodes) return;
    let t = this.getIterator(), r, i;
    for (; this.indexes[t] < this.proxyOf.nodes.length && (r = this.indexes[t], i = e(this.proxyOf.nodes[r], r), i !== !1); )
      this.indexes[t] += 1;
    return delete this.indexes[t], i;
  }
  every(e) {
    return this.nodes.every(e);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let e = this.lastEach;
    return this.indexes[e] = 0, e;
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : e[t] ? t === "each" || typeof t == "string" && t.startsWith("walk") ? (...r) => e[t](
          ...r.map((i) => typeof i == "function" ? (n, l) => i(n.toProxy(), l) : i)
        ) : t === "every" || t === "some" ? (r) => e[t](
          (i, ...n) => r(i.toProxy(), ...n)
        ) : t === "root" ? () => e.root().toProxy() : t === "nodes" ? e.nodes.map((r) => r.toProxy()) : t === "first" || t === "last" ? e[t].toProxy() : e[t] : e[t];
      },
      set(e, t, r) {
        return e[t] === r || (e[t] = r, (t === "name" || t === "params" || t === "selector") && e.markDirty()), !0;
      }
    };
  }
  index(e) {
    return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
  }
  insertAfter(e, t) {
    let r = this.index(e), i = this.normalize(t, this.proxyOf.nodes[r]).reverse();
    r = this.index(e);
    for (let l of i) this.proxyOf.nodes.splice(r + 1, 0, l);
    let n;
    for (let l in this.indexes)
      n = this.indexes[l], r < n && (this.indexes[l] = n + i.length);
    return this.markDirty(), this;
  }
  insertBefore(e, t) {
    let r = this.index(e), i = r === 0 ? "prepend" : !1, n = this.normalize(
      t,
      this.proxyOf.nodes[r],
      i
    ).reverse();
    r = this.index(e);
    for (let a of n) this.proxyOf.nodes.splice(r, 0, a);
    let l;
    for (let a in this.indexes)
      l = this.indexes[a], r <= l && (this.indexes[a] = l + n.length);
    return this.markDirty(), this;
  }
  normalize(e, t) {
    if (typeof e == "string")
      e = Vt(jt(e).nodes);
    else if (typeof e > "u")
      e = [];
    else if (Array.isArray(e)) {
      e = e.slice(0);
      for (let i of e)
        i.parent && i.parent.removeChild(i, "ignore");
    } else if (e.type === "root" && this.type !== "document") {
      e = e.nodes.slice(0);
      for (let i of e)
        i.parent && i.parent.removeChild(i, "ignore");
    } else if (e.type)
      e = [e];
    else if (e.prop) {
      if (typeof e.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof e.value != "string" && (e.value = String(e.value)), e = [new Ft(e)];
    } else if (e.selector || e.selectors)
      e = [new tt(e)];
    else if (e.name)
      e = [new et(e)];
    else if (e.text)
      e = [new Bt(e)];
    else
      throw new Error("Unknown node type in node creation");
    return e.map((i) => (i[Wt] || Jt.rebuild(i), i = i.proxyOf, i.parent && i.parent.removeChild(i), i[zt] && Ht(i), i.raws || (i.raws = {}), typeof i.raws.before > "u" && t && typeof t.raws.before < "u" && (i.raws.before = t.raws.before.replace(/\S/g, "")), i.parent = this.proxyOf, i));
  }
  prepend(...e) {
    e = e.reverse();
    for (let t of e) {
      let r = this.normalize(t, this.first, "prepend").reverse();
      for (let i of r) this.proxyOf.nodes.unshift(i);
      for (let i in this.indexes)
        this.indexes[i] = this.indexes[i] + r.length;
    }
    return this.markDirty(), this;
  }
  push(e) {
    return e.parent = this, this.proxyOf.nodes.push(e), this;
  }
  removeAll() {
    for (let e of this.proxyOf.nodes) e.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(e) {
    e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
    let t;
    for (let r in this.indexes)
      t = this.indexes[r], t >= e && (this.indexes[r] = t - 1);
    return this.markDirty(), this;
  }
  replaceValues(e, t, r) {
    return r || (r = t, t = {}), this.walkDecls((i) => {
      t.props && !t.props.includes(i.prop) || t.fast && !i.value.includes(t.fast) || (i.value = i.value.replace(e, r));
    }), this.markDirty(), this;
  }
  some(e) {
    return this.nodes.some(e);
  }
  walk(e) {
    return this.each((t, r) => {
      let i;
      try {
        i = e(t, r);
      } catch (n) {
        throw t.addToError(n);
      }
      return i !== !1 && t.walk && (i = t.walk(e)), i;
    });
  }
  walkAtRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((r, i) => {
      if (r.type === "atrule" && e.test(r.name))
        return t(r, i);
    }) : this.walk((r, i) => {
      if (r.type === "atrule" && r.name === e)
        return t(r, i);
    }) : (t = e, this.walk((r, i) => {
      if (r.type === "atrule")
        return t(r, i);
    }));
  }
  walkComments(e) {
    return this.walk((t, r) => {
      if (t.type === "comment")
        return e(t, r);
    });
  }
  walkDecls(e, t) {
    return t ? e instanceof RegExp ? this.walk((r, i) => {
      if (r.type === "decl" && e.test(r.prop))
        return t(r, i);
    }) : this.walk((r, i) => {
      if (r.type === "decl" && r.prop === e)
        return t(r, i);
    }) : (t = e, this.walk((r, i) => {
      if (r.type === "decl")
        return t(r, i);
    }));
  }
  walkRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((r, i) => {
      if (r.type === "rule" && e.test(r.selector))
        return t(r, i);
    }) : this.walk((r, i) => {
      if (r.type === "rule" && r.selector === e)
        return t(r, i);
    }) : (t = e, this.walk((r, i) => {
      if (r.type === "rule")
        return t(r, i);
    }));
  }
};
T.registerParse = (s) => {
  jt = s;
};
T.registerRule = (s) => {
  tt = s;
};
T.registerAtRule = (s) => {
  et = s;
};
T.registerRoot = (s) => {
  Gt = s;
};
var D = T;
T.default = T;
T.rebuild = (s) => {
  s.type === "atrule" ? Object.setPrototypeOf(s, et.prototype) : s.type === "rule" ? Object.setPrototypeOf(s, tt.prototype) : s.type === "decl" ? Object.setPrototypeOf(s, Ft.prototype) : s.type === "comment" ? Object.setPrototypeOf(s, Bt.prototype) : s.type === "root" && Object.setPrototypeOf(s, Gt.prototype), s[Wt] = !0, s.nodes && s.nodes.forEach((e) => {
    T.rebuild(e);
  });
};
let Yt = D, ge = class extends Yt {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var rt = ge;
ge.default = ge;
Yt.registerAtRule(ge);
let ys = D, qt, Qt, X = class extends ys {
  constructor(e) {
    super({ type: "document", ...e }), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new qt(new Qt(), this, e).stringify();
  }
};
X.registerLazyResult = (s) => {
  qt = s;
};
X.registerProcessor = (s) => {
  Qt = s;
};
var st = X;
X.default = X;
let ws = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", bs = (s = 21) => {
  let e = "", t = s | 0;
  for (; t--; )
    e += ws[Math.random() * 64 | 0];
  return e;
};
var Cs = { nanoid: bs };
let { existsSync: Ss, readFileSync: xs } = $, { dirname: Me, join: vs } = $, { SourceMapConsumer: mt, SourceMapGenerator: gt } = $;
function Es(s) {
  return Buffer ? Buffer.from(s, "base64").toString() : window.atob(s);
}
let We = class {
  constructor(e, t) {
    if (t.map === !1) return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let r = t.map ? t.map.prev : void 0, i = this.loadMap(t.from, r);
    !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = Me(this.mapFile)), i && (this.text = i);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new mt(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let t = /^data:application\/json;charset=utf-?8;base64,/, r = /^data:application\/json;base64,/, i = /^data:application\/json;charset=utf-?8,/, n = /^data:application\/json,/, l = e.match(i) || e.match(n);
    if (l)
      return decodeURIComponent(e.substr(l[0].length));
    let a = e.match(t) || e.match(r);
    if (a)
      return Es(e.substr(a[0].length));
    let o = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + o);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let t = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!t) return;
    let r = e.lastIndexOf(t.pop()), i = e.indexOf("*/", r);
    r > -1 && i > -1 && (this.annotation = this.getAnnotationURL(e.substring(r, i)));
  }
  loadFile(e) {
    if (this.root = Me(e), Ss(e))
      return this.mapFile = e, xs(e, "utf-8").toString().trim();
  }
  loadMap(e, t) {
    if (t === !1) return !1;
    if (t) {
      if (typeof t == "string")
        return t;
      if (typeof t == "function") {
        let r = t(e);
        if (r) {
          let i = this.loadFile(r);
          if (!i)
            throw new Error(
              "Unable to load previous source map: " + r.toString()
            );
          return i;
        }
      } else {
        if (t instanceof mt)
          return gt.fromSourceMap(t).toString();
        if (t instanceof gt)
          return t.toString();
        if (this.isMap(t))
          return JSON.stringify(t);
        throw new Error(
          "Unsupported previous source map format: " + t.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let r = this.annotation;
        return e && (r = vs(Me(e), r)), this.loadFile(r);
      }
    }
  }
  startWith(e, t) {
    return e ? e.substr(0, t.length) === t : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var Kt = We;
We.default = We;
let { nanoid: Rs } = Cs, { isAbsolute: je, resolve: Ge } = $, { SourceMapConsumer: Os, SourceMapGenerator: ks } = $, { fileURLToPath: yt, pathToFileURL: ie } = $, wt = Ze, Ns = Kt, Pe = $, Ie = Symbol("fromOffsetCache"), As = !!(Os && ks), bt = !!(Ge && je), ye = class {
  get from() {
    return this.file || this.id;
  }
  constructor(e, t = {}) {
    if (e === null || typeof e > "u" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, t.document && (this.document = t.document.toString()), t.from && (!bt || /^\w+:\/\//.test(t.from) || je(t.from) ? this.file = t.from : this.file = Ge(t.from)), bt && As) {
      let r = new Ns(this.css, t);
      if (r.text) {
        this.map = r;
        let i = r.consumer().file;
        !this.file && i && (this.file = this.mapResolve(i));
      }
    }
    this.file || (this.id = "<input css " + Rs(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, t, r, i = {}) {
    let n, l, a;
    if (t && typeof t == "object") {
      let f = t, u = r;
      if (typeof f.offset == "number") {
        let h = this.fromOffset(f.offset);
        t = h.line, r = h.col;
      } else
        t = f.line, r = f.column;
      if (typeof u.offset == "number") {
        let h = this.fromOffset(u.offset);
        l = h.line, n = h.col;
      } else
        l = u.line, n = u.column;
    } else if (!r) {
      let f = this.fromOffset(t);
      t = f.line, r = f.col;
    }
    let o = this.origin(t, r, l, n);
    return o ? a = new wt(
      e,
      o.endLine === void 0 ? o.line : { column: o.column, line: o.line },
      o.endLine === void 0 ? o.column : { column: o.endColumn, line: o.endLine },
      o.source,
      o.file,
      i.plugin
    ) : a = new wt(
      e,
      l === void 0 ? t : { column: r, line: t },
      l === void 0 ? r : { column: n, line: l },
      this.css,
      this.file,
      i.plugin
    ), a.input = { column: r, endColumn: n, endLine: l, line: t, source: this.css }, this.file && (ie && (a.input.url = ie(this.file).toString()), a.input.file = this.file), a;
  }
  fromOffset(e) {
    let t, r;
    if (this[Ie])
      r = this[Ie];
    else {
      let n = this.css.split(`
`);
      r = new Array(n.length);
      let l = 0;
      for (let a = 0, o = n.length; a < o; a++)
        r[a] = l, l += n[a].length + 1;
      this[Ie] = r;
    }
    t = r[r.length - 1];
    let i = 0;
    if (e >= t)
      i = r.length - 1;
    else {
      let n = r.length - 2, l;
      for (; i < n; )
        if (l = i + (n - i >> 1), e < r[l])
          n = l - 1;
        else if (e >= r[l + 1])
          i = l + 1;
        else {
          i = l;
          break;
        }
    }
    return {
      col: e - r[i] + 1,
      line: i + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : Ge(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, t, r, i) {
    if (!this.map) return !1;
    let n = this.map.consumer(), l = n.originalPositionFor({ column: t, line: e });
    if (!l.source) return !1;
    let a;
    typeof r == "number" && (a = n.originalPositionFor({ column: i, line: r }));
    let o;
    je(l.source) ? o = ie(l.source) : o = new URL(
      l.source,
      this.map.consumer().sourceRoot || ie(this.map.mapFile)
    );
    let f = {
      column: l.column,
      endColumn: a && a.column,
      endLine: a && a.line,
      line: l.line,
      url: o.toString()
    };
    if (o.protocol === "file:")
      if (yt)
        f.file = yt(o);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let u = n.sourceContentFor(l.source);
    return u && (f.source = u), f;
  }
  toJSON() {
    let e = {};
    for (let t of ["hasBOM", "css", "file", "id"])
      this[t] != null && (e[t] = this[t]);
    return this.map && (e.map = { ...this.map }, e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
};
var Oe = ye;
ye.default = ye;
Pe && Pe.registerInput && Pe.registerInput(ye);
let Xt = D, Zt, er, j = class extends Xt {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, t, r) {
    let i = super.normalize(e);
    if (t) {
      if (r === "prepend")
        this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;
      else if (this.first !== t)
        for (let n of i)
          n.raws.before = t.raws.before;
    }
    return i;
  }
  removeChild(e, t) {
    let r = this.index(e);
    return !t && r === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[r].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new Zt(new er(), this, e).stringify();
  }
};
j.registerLazyResult = (s) => {
  Zt = s;
};
j.registerProcessor = (s) => {
  er = s;
};
var se = j;
j.default = j;
Xt.registerRoot(j);
let Z = {
  comma(s) {
    return Z.split(s, [","], !0);
  },
  space(s) {
    let e = [" ", `
`, "	"];
    return Z.split(s, e);
  },
  split(s, e, t) {
    let r = [], i = "", n = !1, l = 0, a = !1, o = "", f = !1;
    for (let u of s)
      f ? f = !1 : u === "\\" ? f = !0 : a ? u === o && (a = !1) : u === '"' || u === "'" ? (a = !0, o = u) : u === "(" ? l += 1 : u === ")" ? l > 0 && (l -= 1) : l === 0 && e.includes(u) && (n = !0), n ? (i !== "" && r.push(i.trim()), i = "", n = !1) : i += u;
    return (t || i !== "") && r.push(i.trim()), r;
  }
};
var tr = Z;
Z.default = Z;
let rr = D, Ms = tr, we = class extends rr {
  get selectors() {
    return Ms.comma(this.selector);
  }
  set selectors(e) {
    let t = this.selector ? this.selector.match(/,\s*/) : null, r = t ? t[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(r);
  }
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var it = we;
we.default = we;
rr.registerRule(we);
let Ps = rt, Is = Ee, _s = Re, $s = Oe, Ls = Kt, Ts = se, Ds = it;
function ee(s, e) {
  if (Array.isArray(s)) return s.map((i) => ee(i));
  let { inputs: t, ...r } = s;
  if (t) {
    e = [];
    for (let i of t) {
      let n = { ...i, __proto__: $s.prototype };
      n.map && (n.map = {
        ...n.map,
        __proto__: Ls.prototype
      }), e.push(n);
    }
  }
  if (r.nodes && (r.nodes = s.nodes.map((i) => ee(i, e))), r.source) {
    let { inputId: i, ...n } = r.source;
    r.source = n, i != null && (r.source.input = e[i]);
  }
  if (r.type === "root")
    return new Ts(r);
  if (r.type === "decl")
    return new _s(r);
  if (r.type === "rule")
    return new Ds(r);
  if (r.type === "comment")
    return new Is(r);
  if (r.type === "atrule")
    return new Ps(r);
  throw new Error("Unknown node type: " + s.type);
}
var Us = ee;
ee.default = ee;
let { dirname: he, relative: sr, resolve: ir, sep: nr } = $, { SourceMapConsumer: or, SourceMapGenerator: pe } = $, { pathToFileURL: Ct } = $, Bs = Oe, Fs = !!(or && pe), zs = !!(he && ir && sr && nr), Ws = class {
  constructor(e, t, r, i) {
    this.stringify = e, this.mapOpts = r.map || {}, this.root = t, this.opts = r, this.css = i, this.originalCSS = i, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let t = `
`;
    this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let t = this.toUrl(this.path(e.file)), r = e.root || he(e.file), i;
      this.mapOpts.sourcesContent === !1 ? (i = new or(e.text), i.sourcesContent && (i.sourcesContent = null)) : i = e.consumer(), this.map.applySourceMap(i, t, this.toUrl(this.path(r)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let t = this.root.nodes.length - 1; t >= 0; t--)
          e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
      } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), zs && Fs && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (t) => {
        e += t;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = pe.fromSourceMap(e, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new pe({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new pe({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let e = 1, t = 1, r = "<no source>", i = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, n, l;
    this.stringify(this.root, (a, o, f) => {
      if (this.css += a, o && f !== "end" && (i.generated.line = e, i.generated.column = t - 1, o.source && o.source.start ? (i.source = this.sourcePath(o), i.original.line = o.source.start.line, i.original.column = o.source.start.column - 1, this.map.addMapping(i)) : (i.source = r, i.original.line = 1, i.original.column = 0, this.map.addMapping(i))), l = a.match(/\n/g), l ? (e += l.length, n = a.lastIndexOf(`
`), t = a.length - n) : t += a.length, o && f !== "start") {
        let u = o.parent || { raws: {} };
        (!(o.type === "decl" || o.type === "atrule" && !o.nodes) || o !== u.last || u.raws.semicolon) && (o.source && o.source.end ? (i.source = this.sourcePath(o), i.original.line = o.source.end.line, i.original.column = o.source.end.column - 1, i.generated.line = e, i.generated.column = t - 2, this.map.addMapping(i)) : (i.source = r, i.original.line = 1, i.original.column = 0, i.generated.line = e, i.generated.column = t - 1, this.map.addMapping(i)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e < "u" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
    let t = this.memoizedPaths.get(e);
    if (t) return t;
    let r = this.opts.to ? he(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (r = he(ir(r, this.mapOpts.annotation)));
    let i = sr(r, e);
    return this.memoizedPaths.set(e, i), i;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let t = e.source.input.map;
            this.previousMaps.includes(t) || this.previousMaps.push(t);
          }
        });
      else {
        let e = new Bs(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((t) => {
        if (t.source) {
          let r = t.source.input.from;
          if (r && !e[r]) {
            e[r] = !0;
            let i = this.usesFileUrls ? this.toFileUrl(r) : this.toUrl(this.path(r));
            this.map.setSourceContent(i, t.source.input.css);
          }
        }
      });
    else if (this.css) {
      let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(t, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let t = this.memoizedFileURLs.get(e);
    if (t) return t;
    if (Ct) {
      let r = Ct(e).toString();
      return this.memoizedFileURLs.set(e, r), r;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let t = this.memoizedURLs.get(e);
    if (t) return t;
    nr === "\\" && (e = e.replace(/\\/g, "/"));
    let r = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, r), r;
  }
};
var lr = Ws;
const _e = 39, St = 34, ne = 92, xt = 47, oe = 10, q = 32, le = 12, ae = 9, ue = 13, js = 91, Gs = 93, Vs = 40, Hs = 41, Js = 123, Ys = 125, qs = 59, Qs = 42, Ks = 58, Xs = 64, fe = /[\t\n\f\r "#'()/;[\\\]{}]/g, ce = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, Zs = /.[\r\n"'(/\\]/, vt = /[\da-f]/i;
var ei = function(e, t = {}) {
  let r = e.css.valueOf(), i = t.ignoreErrors, n, l, a, o, f, u, h, d, g, E, R = r.length, c = 0, m = [], k = [];
  function M() {
    return c;
  }
  function p(A) {
    throw e.error("Unclosed " + A, c);
  }
  function b() {
    return k.length === 0 && c >= R;
  }
  function O(A) {
    if (k.length) return k.pop();
    if (c >= R) return;
    let N = A ? A.ignoreUnclosed : !1;
    switch (n = r.charCodeAt(c), n) {
      case oe:
      case q:
      case ae:
      case ue:
      case le: {
        o = c;
        do
          o += 1, n = r.charCodeAt(o);
        while (n === q || n === oe || n === ae || n === ue || n === le);
        u = ["space", r.slice(c, o)], c = o - 1;
        break;
      }
      case js:
      case Gs:
      case Js:
      case Ys:
      case Ks:
      case qs:
      case Hs: {
        let _ = String.fromCharCode(n);
        u = [_, _, c];
        break;
      }
      case Vs: {
        if (E = m.length ? m.pop()[1] : "", g = r.charCodeAt(c + 1), E === "url" && g !== _e && g !== St && g !== q && g !== oe && g !== ae && g !== le && g !== ue) {
          o = c;
          do {
            if (h = !1, o = r.indexOf(")", o + 1), o === -1)
              if (i || N) {
                o = c;
                break;
              } else
                p("bracket");
            for (d = o; r.charCodeAt(d - 1) === ne; )
              d -= 1, h = !h;
          } while (h);
          u = ["brackets", r.slice(c, o + 1), c, o], c = o;
        } else
          o = r.indexOf(")", c + 1), l = r.slice(c, o + 1), o === -1 || Zs.test(l) ? u = ["(", "(", c] : (u = ["brackets", l, c, o], c = o);
        break;
      }
      case _e:
      case St: {
        f = n === _e ? "'" : '"', o = c;
        do {
          if (h = !1, o = r.indexOf(f, o + 1), o === -1)
            if (i || N) {
              o = c + 1;
              break;
            } else
              p("string");
          for (d = o; r.charCodeAt(d - 1) === ne; )
            d -= 1, h = !h;
        } while (h);
        u = ["string", r.slice(c, o + 1), c, o], c = o;
        break;
      }
      case Xs: {
        fe.lastIndex = c + 1, fe.test(r), fe.lastIndex === 0 ? o = r.length - 1 : o = fe.lastIndex - 2, u = ["at-word", r.slice(c, o + 1), c, o], c = o;
        break;
      }
      case ne: {
        for (o = c, a = !0; r.charCodeAt(o + 1) === ne; )
          o += 1, a = !a;
        if (n = r.charCodeAt(o + 1), a && n !== xt && n !== q && n !== oe && n !== ae && n !== ue && n !== le && (o += 1, vt.test(r.charAt(o)))) {
          for (; vt.test(r.charAt(o + 1)); )
            o += 1;
          r.charCodeAt(o + 1) === q && (o += 1);
        }
        u = ["word", r.slice(c, o + 1), c, o], c = o;
        break;
      }
      default: {
        n === xt && r.charCodeAt(c + 1) === Qs ? (o = r.indexOf("*/", c + 2) + 1, o === 0 && (i || N ? o = r.length : p("comment")), u = ["comment", r.slice(c, o + 1), c, o], c = o) : (ce.lastIndex = c + 1, ce.test(r), ce.lastIndex === 0 ? o = r.length - 1 : o = ce.lastIndex - 2, u = ["word", r.slice(c, o + 1), c, o], m.push(u), c = o);
        break;
      }
    }
    return c++, u;
  }
  function I(A) {
    k.push(A);
  }
  return {
    back: I,
    endOfFile: b,
    nextToken: O,
    position: M
  };
};
let ti = rt, ri = Ee, si = Re, ii = se, Et = it, ni = ei;
const Rt = {
  empty: !0,
  space: !0
};
function oi(s) {
  for (let e = s.length - 1; e >= 0; e--) {
    let t = s[e], r = t[3] || t[2];
    if (r) return r;
  }
}
let li = class {
  constructor(e) {
    this.input = e, this.root = new ii(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let t = new ti();
    t.name = e[1].slice(1), t.name === "" && this.unnamedAtrule(t, e), this.init(t, e[2]);
    let r, i, n, l = !1, a = !1, o = [], f = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), r = e[0], r === "(" || r === "[" ? f.push(r === "(" ? ")" : "]") : r === "{" && f.length > 0 ? f.push("}") : r === f[f.length - 1] && f.pop(), f.length === 0)
        if (r === ";") {
          t.source.end = this.getPosition(e[2]), t.source.end.offset++, this.semicolon = !0;
          break;
        } else if (r === "{") {
          a = !0;
          break;
        } else if (r === "}") {
          if (o.length > 0) {
            for (n = o.length - 1, i = o[n]; i && i[0] === "space"; )
              i = o[--n];
            i && (t.source.end = this.getPosition(i[3] || i[2]), t.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          o.push(e);
      else
        o.push(e);
      if (this.tokenizer.endOfFile()) {
        l = !0;
        break;
      }
    }
    t.raws.between = this.spacesAndCommentsFromEnd(o), o.length ? (t.raws.afterName = this.spacesAndCommentsFromStart(o), this.raw(t, "params", o), l && (e = o[o.length - 1], t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++, this.spaces = t.raws.between, t.raws.between = "")) : (t.raws.afterName = "", t.params = ""), a && (t.nodes = [], this.current = t);
  }
  checkMissedSemicolon(e) {
    let t = this.colon(e);
    if (t === !1) return;
    let r = 0, i;
    for (let n = t - 1; n >= 0 && (i = e[n], !(i[0] !== "space" && (r += 1, r === 2))); n--)
      ;
    throw this.input.error(
      "Missed semicolon",
      i[0] === "word" ? i[3] + 1 : i[2]
    );
  }
  colon(e) {
    let t = 0, r, i, n;
    for (let [l, a] of e.entries()) {
      if (i = a, n = i[0], n === "(" && (t += 1), n === ")" && (t -= 1), t === 0 && n === ":")
        if (!r)
          this.doubleColon(i);
        else {
          if (r[0] === "word" && r[1] === "progid")
            continue;
          return l;
        }
      r = i;
    }
    return !1;
  }
  comment(e) {
    let t = new ri();
    this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
    let r = e[1].slice(2, -2);
    if (/^\s*$/.test(r))
      t.text = "", t.raws.left = r, t.raws.right = "";
    else {
      let i = r.match(/^(\s*)([^]*\S)(\s*)$/);
      t.text = i[2], t.raws.left = i[1], t.raws.right = i[3];
    }
  }
  createTokenizer() {
    this.tokenizer = ni(this.input);
  }
  decl(e, t) {
    let r = new si();
    this.init(r, e[0][2]);
    let i = e[e.length - 1];
    for (i[0] === ";" && (this.semicolon = !0, e.pop()), r.source.end = this.getPosition(
      i[3] || i[2] || oi(e)
    ), r.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), r.raws.before += e.shift()[1];
    for (r.source.start = this.getPosition(e[0][2]), r.prop = ""; e.length; ) {
      let f = e[0][0];
      if (f === ":" || f === "space" || f === "comment")
        break;
      r.prop += e.shift()[1];
    }
    r.raws.between = "";
    let n;
    for (; e.length; )
      if (n = e.shift(), n[0] === ":") {
        r.raws.between += n[1];
        break;
      } else
        n[0] === "word" && /\w/.test(n[1]) && this.unknownWord([n]), r.raws.between += n[1];
    (r.prop[0] === "_" || r.prop[0] === "*") && (r.raws.before += r.prop[0], r.prop = r.prop.slice(1));
    let l = [], a;
    for (; e.length && (a = e[0][0], !(a !== "space" && a !== "comment")); )
      l.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let f = e.length - 1; f >= 0; f--) {
      if (n = e[f], n[1].toLowerCase() === "!important") {
        r.important = !0;
        let u = this.stringFrom(e, f);
        u = this.spacesFromEnd(e) + u, u !== " !important" && (r.raws.important = u);
        break;
      } else if (n[1].toLowerCase() === "important") {
        let u = e.slice(0), h = "";
        for (let d = f; d > 0; d--) {
          let g = u[d][0];
          if (h.trim().startsWith("!") && g !== "space")
            break;
          h = u.pop()[1] + h;
        }
        h.trim().startsWith("!") && (r.important = !0, r.raws.important = h, e = u);
      }
      if (n[0] !== "space" && n[0] !== "comment")
        break;
    }
    e.some((f) => f[0] !== "space" && f[0] !== "comment") && (r.raws.between += l.map((f) => f[1]).join(""), l = []), this.raw(r, "value", l.concat(e), t), r.value.includes(":") && !t && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let t = new Et();
    this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let t = this.current.nodes[this.current.nodes.length - 1];
      t && t.type === "rule" && !t.raws.ownSemicolon && (t.raws.ownSemicolon = this.spaces, this.spaces = "", t.source.end = this.getPosition(e[2]), t.source.end.offset += t.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(e) {
    let t = this.input.fromOffset(e);
    return {
      column: t.col,
      line: t.line,
      offset: e
    };
  }
  init(e, t) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(t)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let t = !1, r = null, i = !1, n = null, l = [], a = e[1].startsWith("--"), o = [], f = e;
    for (; f; ) {
      if (r = f[0], o.push(f), r === "(" || r === "[")
        n || (n = f), l.push(r === "(" ? ")" : "]");
      else if (a && i && r === "{")
        n || (n = f), l.push("}");
      else if (l.length === 0)
        if (r === ";")
          if (i) {
            this.decl(o, a);
            return;
          } else
            break;
        else if (r === "{") {
          this.rule(o);
          return;
        } else if (r === "}") {
          this.tokenizer.back(o.pop()), t = !0;
          break;
        } else r === ":" && (i = !0);
      else r === l[l.length - 1] && (l.pop(), l.length === 0 && (n = null));
      f = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (t = !0), l.length > 0 && this.unclosedBracket(n), t && i) {
      if (!a)
        for (; o.length && (f = o[o.length - 1][0], !(f !== "space" && f !== "comment")); )
          this.tokenizer.back(o.pop());
      this.decl(o, a);
    } else
      this.unknownWord(o);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, t, r, i) {
    let n, l, a = r.length, o = "", f = !0, u, h;
    for (let d = 0; d < a; d += 1)
      n = r[d], l = n[0], l === "space" && d === a - 1 && !i ? f = !1 : l === "comment" ? (h = r[d - 1] ? r[d - 1][0] : "empty", u = r[d + 1] ? r[d + 1][0] : "empty", !Rt[h] && !Rt[u] ? o.slice(-1) === "," ? f = !1 : o += n[1] : f = !1) : o += n[1];
    if (!f) {
      let d = r.reduce((g, E) => g + E[1], "");
      e.raws[t] = { raw: d, value: o };
    }
    e[t] = o;
  }
  rule(e) {
    e.pop();
    let t = new Et();
    this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
  }
  spacesAndCommentsFromEnd(e) {
    let t, r = "";
    for (; e.length && (t = e[e.length - 1][0], !(t !== "space" && t !== "comment")); )
      r = e.pop()[1] + r;
    return r;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let t, r = "";
    for (; e.length && (t = e[0][0], !(t !== "space" && t !== "comment")); )
      r += e.shift()[1];
    return r;
  }
  spacesFromEnd(e) {
    let t, r = "";
    for (; e.length && (t = e[e.length - 1][0], t === "space"); )
      r = e.pop()[1] + r;
    return r;
  }
  stringFrom(e, t) {
    let r = "";
    for (let i = t; i < e.length; i++)
      r += e[i][1];
    return e.splice(t, e.length - t), r;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word " + e[0][1],
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, t) {
    throw this.input.error(
      "At-rule without name",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
};
var ai = li;
let ui = D, fi = Oe, ci = ai;
function be(s, e) {
  let t = new fi(s, e), r = new ci(t);
  try {
    r.parse();
  } catch (i) {
    throw process.env.NODE_ENV !== "production" && i.name === "CssSyntaxError" && e && e.from && (/\.scss$/i.test(e.from) ? i.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(e.from) ? i.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(e.from) && (i.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), i;
  }
  return r.root;
}
var nt = be;
be.default = be;
ui.registerParse(be);
let Ve = class {
  constructor(e, t = {}) {
    if (this.type = "warning", this.text = e, t.node && t.node.source) {
      let r = t.node.rangeBy(t);
      this.line = r.start.line, this.column = r.start.column, this.endLine = r.end.line, this.endColumn = r.end.column;
    }
    for (let r in t) this[r] = t[r];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var ar = Ve;
Ve.default = Ve;
let hi = ar, He = class {
  get content() {
    return this.css;
  }
  constructor(e, t, r) {
    this.processor = e, this.messages = [], this.root = t, this.opts = r, this.css = void 0, this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, t = {}) {
    t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
    let r = new hi(e, t);
    return this.messages.push(r), r;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
};
var ot = He;
He.default = He;
let Ot = {};
var ur = function(e) {
  Ot[e] || (Ot[e] = !0, typeof console < "u" && console.warn && console.warn(e));
};
let pi = D, di = st, mi = lr, gi = nt, kt = ot, yi = se, wi = xe, { isClean: L, my: bi } = re, Ci = ur;
const Si = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, xi = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, vi = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, G = 0;
function Q(s) {
  return typeof s == "object" && typeof s.then == "function";
}
function fr(s) {
  let e = !1, t = Si[s.type];
  return s.type === "decl" ? e = s.prop.toLowerCase() : s.type === "atrule" && (e = s.name.toLowerCase()), e && s.append ? [
    t,
    t + "-" + e,
    G,
    t + "Exit",
    t + "Exit-" + e
  ] : e ? [t, t + "-" + e, t + "Exit", t + "Exit-" + e] : s.append ? [t, G, t + "Exit"] : [t, t + "Exit"];
}
function Nt(s) {
  let e;
  return s.type === "document" ? e = ["Document", G, "DocumentExit"] : s.type === "root" ? e = ["Root", G, "RootExit"] : e = fr(s), {
    eventIndex: 0,
    events: e,
    iterator: 0,
    node: s,
    visitorIndex: 0,
    visitors: []
  };
}
function Je(s) {
  return s[L] = !1, s.nodes && s.nodes.forEach((e) => Je(e)), s;
}
let Ye = {}, V = class cr {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(e, t, r) {
    this.stringified = !1, this.processed = !1;
    let i;
    if (typeof t == "object" && t !== null && (t.type === "root" || t.type === "document"))
      i = Je(t);
    else if (t instanceof cr || t instanceof kt)
      i = Je(t.root), t.map && (typeof r.map > "u" && (r.map = {}), r.map.inline || (r.map.inline = !1), r.map.prev = t.map);
    else {
      let n = gi;
      r.syntax && (n = r.syntax.parse), r.parser && (n = r.parser), n.parse && (n = n.parse);
      try {
        i = n(t, r);
      } catch (l) {
        this.processed = !0, this.error = l;
      }
      i && !i[bi] && pi.rebuild(i);
    }
    this.result = new kt(e, i, r), this.helpers = { ...Ye, postcss: Ye, result: this.result }, this.plugins = this.processor.plugins.map((n) => typeof n == "object" && n.prepare ? { ...n, ...n.prepare(this.result) } : n);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(e, t) {
    let r = this.result.lastPlugin;
    try {
      if (t && t.addToError(e), this.error = e, e.name === "CssSyntaxError" && !e.plugin)
        e.plugin = r.postcssPlugin, e.setMessage();
      else if (r.postcssVersion && process.env.NODE_ENV !== "production") {
        let i = r.postcssPlugin, n = r.postcssVersion, l = this.result.processor.version, a = n.split("."), o = l.split(".");
        (a[0] !== o[0] || parseInt(a[1]) > parseInt(o[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + l + ", but " + i + " uses " + n + ". Perhaps this is the source of the error below."
        );
      }
    } catch (i) {
      console && console.error && console.error(i);
    }
    return e;
  }
  prepareVisitors() {
    this.listeners = {};
    let e = (t, r, i) => {
      this.listeners[r] || (this.listeners[r] = []), this.listeners[r].push([t, i]);
    };
    for (let t of this.plugins)
      if (typeof t == "object")
        for (let r in t) {
          if (!xi[r] && /^[A-Z]/.test(r))
            throw new Error(
              `Unknown event ${r} in ${t.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!vi[r])
            if (typeof t[r] == "object")
              for (let i in t[r])
                i === "*" ? e(t, r, t[r][i]) : e(
                  t,
                  r + "-" + i.toLowerCase(),
                  t[r][i]
                );
            else typeof t[r] == "function" && e(t, r, t[r]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let e = 0; e < this.plugins.length; e++) {
      let t = this.plugins[e], r = this.runOnRoot(t);
      if (Q(r))
        try {
          await r;
        } catch (i) {
          throw this.handleError(i);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[L]; ) {
        e[L] = !0;
        let t = [Nt(e)];
        for (; t.length > 0; ) {
          let r = this.visitTick(t);
          if (Q(r))
            try {
              await r;
            } catch (i) {
              let n = t[t.length - 1].node;
              throw this.handleError(i, n);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [t, r] of this.listeners.OnceExit) {
          this.result.lastPlugin = t;
          try {
            if (e.type === "document") {
              let i = e.nodes.map(
                (n) => r(n, this.helpers)
              );
              await Promise.all(i);
            } else
              await r(e, this.helpers);
          } catch (i) {
            throw this.handleError(i);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(e) {
    this.result.lastPlugin = e;
    try {
      if (typeof e == "object" && e.Once) {
        if (this.result.root.type === "document") {
          let t = this.result.root.nodes.map(
            (r) => e.Once(r, this.helpers)
          );
          return Q(t[0]) ? Promise.all(t) : t;
        }
        return e.Once(this.result.root, this.helpers);
      } else if (typeof e == "function")
        return e(this.result.root, this.result);
    } catch (t) {
      throw this.handleError(t);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let e = this.result.opts, t = wi;
    e.syntax && (t = e.syntax.stringify), e.stringifier && (t = e.stringifier), t.stringify && (t = t.stringify);
    let i = new mi(t, this.result.root, this.result.opts).generate();
    return this.result.css = i[0], this.result.map = i[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let e of this.plugins) {
      let t = this.runOnRoot(e);
      if (Q(t))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[L]; )
        e[L] = !0, this.walkSync(e);
      if (this.listeners.OnceExit)
        if (e.type === "document")
          for (let t of e.nodes)
            this.visitSync(this.listeners.OnceExit, t);
        else
          this.visitSync(this.listeners.OnceExit, e);
    }
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || Ci(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this.css;
  }
  visitSync(e, t) {
    for (let [r, i] of e) {
      this.result.lastPlugin = r;
      let n;
      try {
        n = i(t, this.helpers);
      } catch (l) {
        throw this.handleError(l, t.proxyOf);
      }
      if (t.type !== "root" && t.type !== "document" && !t.parent)
        return !0;
      if (Q(n))
        throw this.getAsyncError();
    }
  }
  visitTick(e) {
    let t = e[e.length - 1], { node: r, visitors: i } = t;
    if (r.type !== "root" && r.type !== "document" && !r.parent) {
      e.pop();
      return;
    }
    if (i.length > 0 && t.visitorIndex < i.length) {
      let [l, a] = i[t.visitorIndex];
      t.visitorIndex += 1, t.visitorIndex === i.length && (t.visitors = [], t.visitorIndex = 0), this.result.lastPlugin = l;
      try {
        return a(r.toProxy(), this.helpers);
      } catch (o) {
        throw this.handleError(o, r);
      }
    }
    if (t.iterator !== 0) {
      let l = t.iterator, a;
      for (; a = r.nodes[r.indexes[l]]; )
        if (r.indexes[l] += 1, !a[L]) {
          a[L] = !0, e.push(Nt(a));
          return;
        }
      t.iterator = 0, delete r.indexes[l];
    }
    let n = t.events;
    for (; t.eventIndex < n.length; ) {
      let l = n[t.eventIndex];
      if (t.eventIndex += 1, l === G) {
        r.nodes && r.nodes.length && (r[L] = !0, t.iterator = r.getIterator());
        return;
      } else if (this.listeners[l]) {
        t.visitors = this.listeners[l];
        return;
      }
    }
    e.pop();
  }
  walkSync(e) {
    e[L] = !0;
    let t = fr(e);
    for (let r of t)
      if (r === G)
        e.nodes && e.each((i) => {
          i[L] || this.walkSync(i);
        });
      else {
        let i = this.listeners[r];
        if (i && this.visitSync(i, e.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
V.registerPostcss = (s) => {
  Ye = s;
};
var hr = V;
V.default = V;
yi.registerLazyResult(V);
di.registerLazyResult(V);
let Ei = lr, Ri = nt;
const Oi = ot;
let ki = xe, Ni = ur, qe = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, t = Ri;
    try {
      e = t(this._css, this._opts);
    } catch (r) {
      this.error = r;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(e, t, r) {
    t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = r, this._map = void 0;
    let i, n = ki;
    this.result = new Oi(this._processor, i, this._opts), this.result.css = t;
    let l = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return l.root;
      }
    });
    let a = new Ei(n, i, this._opts, t);
    if (a.isMap()) {
      let [o, f] = a.generate();
      o && (this.result.css = o), f && (this.result.map = f);
    } else
      a.clearAnnotation(), this.result.css = a.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || Ni(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var Ai = qe;
qe.default = qe;
let Mi = st, Pi = hr, Ii = Ai, _i = se, te = class {
  constructor(e = []) {
    this.version = "8.5.3", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let t = [];
    for (let r of e)
      if (r.postcss === !0 ? r = r() : r.postcss && (r = r.postcss), typeof r == "object" && Array.isArray(r.plugins))
        t = t.concat(r.plugins);
      else if (typeof r == "object" && r.postcssPlugin)
        t.push(r);
      else if (typeof r == "function")
        t.push(r);
      else if (typeof r == "object" && (r.parse || r.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(r + " is not a PostCSS plugin");
    return t;
  }
  process(e, t = {}) {
    return !this.plugins.length && !t.parser && !t.stringifier && !t.syntax ? new Ii(this, e, t) : new Pi(this, e, t);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var $i = te;
te.default = te;
_i.registerProcessor(te);
Mi.registerProcessor(te);
let pr = rt, dr = Ee, Li = D, Ti = Ze, mr = Re, gr = st, Di = Us, Ui = Oe, Bi = hr, Fi = tr, zi = ve, Wi = nt, lt = $i, ji = ot, yr = se, wr = it, Gi = xe, Vi = ar;
function C(...s) {
  return s.length === 1 && Array.isArray(s[0]) && (s = s[0]), new lt(s);
}
C.plugin = function(e, t) {
  let r = !1;
  function i(...l) {
    console && console.warn && !r && (r = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let a = t(...l);
    return a.postcssPlugin = e, a.postcssVersion = new lt().version, a;
  }
  let n;
  return Object.defineProperty(i, "postcss", {
    get() {
      return n || (n = i()), n;
    }
  }), i.process = function(l, a, o) {
    return C([i(o)]).process(l, a);
  }, i;
};
C.stringify = Gi;
C.parse = Wi;
C.fromJSON = Di;
C.list = Fi;
C.comment = (s) => new dr(s);
C.atRule = (s) => new pr(s);
C.decl = (s) => new mr(s);
C.rule = (s) => new wr(s);
C.root = (s) => new yr(s);
C.document = (s) => new gr(s);
C.CssSyntaxError = Ti;
C.Declaration = mr;
C.Container = Li;
C.Processor = lt;
C.Document = gr;
C.Comment = dr;
C.Warning = Vi;
C.AtRule = pr;
C.Result = ji;
C.Input = Ui;
C.Rule = wr;
C.Root = yr;
C.Node = zi;
Bi.registerPostcss(C);
var Hi = C;
C.default = C;
const v = /* @__PURE__ */ ss(Hi);
v.stringify;
v.fromJSON;
v.plugin;
v.parse;
v.list;
v.document;
v.comment;
v.atRule;
v.rule;
v.decl;
v.root;
v.CssSyntaxError;
v.Declaration;
v.Container;
v.Processor;
v.Document;
v.Comment;
v.Warning;
v.AtRule;
v.Result;
v.Input;
v.Rule;
v.Root;
v.Node;
const Ji = /(max|min)-device-(width|height)/, At = new RegExp(Ji.source, "g"), Yi = {
  postcssPlugin: "postcss-custom-selectors",
  prepare() {
    return {
      postcssPlugin: "postcss-custom-selectors",
      AtRule: function(s) {
        s.params.match(At) && (s.params = s.params.replace(At, "$1-$2"));
      }
    };
  }
}, qi = {
  postcssPlugin: "postcss-hover-classes",
  prepare: function() {
    const s = [];
    return {
      Rule: function(e) {
        s.indexOf(e) === -1 && (s.push(e), e.selectors.forEach(function(t) {
          if (!t.includes(":"))
            return;
          const r = t.replace(/\n/g, " ").split(" "), i = [];
          r.forEach(function(l) {
            const a = l.match(/::?([^:]+)/g);
            if (!a) {
              i.push(l);
              return;
            }
            const o = l.substr(
              0,
              l.length - a.join("").length
            ), f = a.map(function(u) {
              return u.replace(/\(.*/g, "") !== ":hover" || u.match(/^::/) ? u : (u = u.substr(1), u = u.replace(/\(/g, "\\("), u = u.replace(/\)/g, "\\)"), ".\\:" + u);
            });
            i.push(o + f.join(""));
          }), n(i.join(" "));
          function n(l) {
            l && l !== t && (e.selector += `,
` + l);
          }
        }));
      }
    };
  }
}, Mt = {
  script: "noscript",
  // camel case svg element tag names
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  fedropshadow: "feDropShadow",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient"
};
function Qi(s) {
  let e = Mt[s.tagName] ? Mt[s.tagName] : s.tagName;
  return e === "link" && s.attributes._cssText && (e = "style"), e;
}
function Pt(s, e) {
  const t = e == null ? void 0 : e.stylesWithHoverClass.get(s);
  if (t) return t;
  const i = v([
    Yi,
    qi
  ]).process(s).css;
  return e == null || e.stylesWithHoverClass.set(s, i), i;
}
function xn() {
  return {
    stylesWithHoverClass: /* @__PURE__ */ new Map()
  };
}
function Ki(s, e) {
  var n;
  const { doc: t, hackCss: r, cache: i } = e;
  switch (s.type) {
    case w.Document:
      return t.implementation.createDocument(null, "", null);
    case w.DocumentType:
      return t.implementation.createDocumentType(
        s.name || "html",
        s.publicId,
        s.systemId
      );
    case w.Element: {
      const l = Qi(s);
      let a;
      s.isSVG ? a = t.createElementNS("http://www.w3.org/2000/svg", l) : (
        // If the tag name is a custom element name
        (s.isCustom && // If the browser supports custom elements
        ((n = t.defaultView) != null && n.customElements) && // If the custom element hasn't been defined yet
        !t.defaultView.customElements.get(s.tagName) && t.defaultView.customElements.define(
          s.tagName,
          class extends t.defaultView.HTMLElement {
          }
        ), a = t.createElement(l))
      );
      const o = {};
      for (const f in s.attributes) {
        if (!Object.prototype.hasOwnProperty.call(s.attributes, f))
          continue;
        let u = s.attributes[f];
        if (l === "option" && f === "selected" && u === !1 || u === null)
          continue;
        if (u === !0 && (u = ""), f.startsWith("rr_")) {
          o[f] = u;
          continue;
        }
        const h = l === "textarea" && f === "value", d = l === "style" && f === "_cssText";
        if (d && r && typeof u == "string" && (u = Pt(u, i)), (h || d) && typeof u == "string") {
          a.appendChild(t.createTextNode(u)), s.childNodes = [];
          continue;
        }
        try {
          if (s.isSVG && f === "xlink:href")
            a.setAttributeNS(
              "http://www.w3.org/1999/xlink",
              f,
              u.toString()
            );
          else if (f === "onload" || f === "onclick" || f.substring(0, 7) === "onmouse")
            a.setAttribute("_" + f, u.toString());
          else if (l === "meta" && s.attributes["http-equiv"] === "Content-Security-Policy" && f === "content") {
            a.setAttribute("csp-content", u.toString());
            continue;
          } else l === "link" && (s.attributes.rel === "preload" || s.attributes.rel === "modulepreload") && s.attributes.as === "script" || l === "link" && s.attributes.rel === "prefetch" && typeof s.attributes.href == "string" && s.attributes.href.endsWith(".js") || (l === "img" && s.attributes.srcset && s.attributes.rr_dataURL ? a.setAttribute("original-srcset", s.attributes.srcset) : a.setAttribute(f, u.toString()));
        } catch {
        }
      }
      for (const f in o) {
        const u = o[f];
        if (l === "canvas" && f === "rr_dataURL") {
          const h = t.createElement("img");
          h.onload = () => {
            const d = a.getContext("2d");
            d && d.drawImage(h, 0, 0, h.width, h.height);
          }, h.src = u.toString(), a.RRNodeType && (a.rr_dataURL = u.toString());
        } else if (l === "img" && f === "rr_dataURL") {
          const h = a;
          h.currentSrc.startsWith("data:") || (h.setAttribute("original-src", s.attributes.src), h.src = u.toString());
        }
        if (f === "rr_width")
          a.style.width = u.toString();
        else if (f === "rr_height")
          a.style.height = u.toString();
        else if (f === "rr_mediaCurrentTime" && typeof u == "number")
          a.currentTime = u;
        else if (f === "rr_mediaState")
          switch (u) {
            case "played":
              a.play().catch((h) => console.warn("media playback error", h));
              break;
            case "paused":
              a.pause();
              break;
          }
        else f === "rr_mediaPlaybackRate" && typeof u == "number" ? a.playbackRate = u : f === "rr_mediaMuted" && typeof u == "boolean" ? a.muted = u : f === "rr_mediaLoop" && typeof u == "boolean" ? a.loop = u : f === "rr_mediaVolume" && typeof u == "number" && (a.volume = u);
      }
      if (s.isShadowHost)
        if (!a.shadowRoot)
          a.attachShadow({ mode: "open" });
        else
          for (; a.shadowRoot.firstChild; )
            a.shadowRoot.removeChild(a.shadowRoot.firstChild);
      return a;
    }
    case w.Text:
      return t.createTextNode(
        s.isStyle && r ? Pt(s.textContent, i) : s.textContent
      );
    case w.CDATA:
      return t.createCDATASection(s.textContent);
    case w.Comment:
      return t.createComment(s.textContent);
    default:
      return null;
  }
}
function br(s, e) {
  const {
    doc: t,
    mirror: r,
    skipChild: i = !1,
    hackCss: n = !0,
    afterAppend: l,
    cache: a
  } = e;
  if (r.has(s.id)) {
    const f = r.getNode(s.id), u = r.getMeta(f);
    if (Ir(u, s)) return r.getNode(s.id);
  }
  let o = Ki(s, { doc: t, hackCss: n, cache: a });
  if (!o)
    return null;
  if (s.rootId && r.getNode(s.rootId) !== t && r.replace(s.rootId, t), s.type === w.Document && (t.close(), t.open(), s.compatMode === "BackCompat" && s.childNodes && s.childNodes[0].type !== w.DocumentType && (s.childNodes[0].type === w.Element && "xmlns" in s.childNodes[0].attributes && s.childNodes[0].attributes.xmlns === "http://www.w3.org/1999/xhtml" ? t.write(
    '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "">'
  ) : t.write(
    '<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "">'
  )), o = t), r.add(o, s), (s.type === w.Document || s.type === w.Element) && !i)
    for (const f of s.childNodes) {
      const u = br(f, {
        doc: t,
        mirror: r,
        skipChild: !1,
        hackCss: n,
        afterAppend: l,
        cache: a
      });
      if (!u) {
        console.warn("Failed to rebuild", f);
        continue;
      }
      if (f.isShadow && Qe(o) && o.shadowRoot)
        o.shadowRoot.appendChild(u);
      else if (s.type === w.Document && f.type == w.Element) {
        const h = u;
        let d = null;
        h.childNodes.forEach((g) => {
          g.nodeName === "BODY" && (d = g);
        }), d ? (h.removeChild(d), o.appendChild(u), h.appendChild(d)) : o.appendChild(u);
      } else
        o.appendChild(u);
      l && l(u, f.id);
    }
  return o;
}
function Xi(s, e) {
  function t(r) {
    e(r);
  }
  for (const r of s.getIds())
    s.has(r) && t(s.getNode(r));
}
function Zi(s, e) {
  const t = e.getMeta(s);
  if ((t == null ? void 0 : t.type) !== w.Element)
    return;
  const r = s;
  for (const i in t.attributes) {
    if (!(Object.prototype.hasOwnProperty.call(t.attributes, i) && i.startsWith("rr_")))
      continue;
    const n = t.attributes[i];
    i === "rr_scrollLeft" && (r.scrollLeft = n), i === "rr_scrollTop" && (r.scrollTop = n);
  }
}
function vn(s, e) {
  const {
    doc: t,
    onVisit: r,
    hackCss: i = !0,
    afterAppend: n,
    cache: l,
    mirror: a = new Ke()
  } = e, o = br(s, {
    doc: t,
    mirror: a,
    skipChild: !1,
    hackCss: i,
    afterAppend: n,
    cache: l
  });
  return Xi(a, (f) => {
    r && r(f), Zi(f, a);
  }), o;
}
export {
  ut as IGNORED_NODE,
  Ke as Mirror,
  w as NodeType,
  Pt as adaptCssForReplay,
  br as buildNodeWithSN,
  $e as classMatchesRegex,
  nn as cleanupSnapshot,
  xn as createCache,
  tn as createMirror,
  Er as escapeImportStatement,
  $t as extractFileExtension,
  Nr as fixSafariColons,
  Lr as genId,
  _r as getInputType,
  Jr as ignoreAttribute,
  Pr as is2DCanvasBlank,
  Ar as isCSSImportRule,
  _t as isCSSStyleRule,
  Qe as isElement,
  Ae as isNativeShadowDom,
  Ir as isNodeMetaEqual,
  xr as isShadowRoot,
  Mr as maskInputValue,
  qr as needMaskingText,
  vn as rebuild,
  K as serializeNodeWithId,
  rn as snapshot,
  kr as stringifyRule,
  de as stringifyStylesheet,
  Ce as toLowerCase,
  Hr as transformAttribute,
  sn as visitSnapshot
};
//# sourceMappingURL=rrweb-snapshot.js.map
